import { createSlice } from "@reduxjs/toolkit";
import { ThunkHttpClient } from "../../utils/httpThunkClient";

export const fetchAllBusinessFrom = ThunkHttpClient.get('master/fetchAllBusinessFrom', 
    () => `master/fetchAllBusinessFrom`);

export const saveBusinessFromAndProfitCenters = ThunkHttpClient.post('master/saveBuninessFromAndProfitCenters', 
    (body) => ({url: 'master/saveBuninessFromAndProfitCenters', body}));

export const activeOrInactiveBusinessFrom = ThunkHttpClient.get('master/activeOrInactiveBusinessFrom', 
    (data) => `master/activeOrInactiveBusinessFrom?id=${data.id}&active=${data.active}`);

const initialState = {
    loading: false
}

export const businessFromSlice = createSlice({
    name: 'businessFrom',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // fetch all business from
        builder.addCase(fetchAllBusinessFrom.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllBusinessFrom.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(fetchAllBusinessFrom.rejected, (state, action) => { 
            state.loading = false;
        });

        // save business from and profit centers
        builder.addCase(saveBusinessFromAndProfitCenters.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(saveBusinessFromAndProfitCenters.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(saveBusinessFromAndProfitCenters.rejected, (state, action) => {
            state.loading = false;
        });
    }
})

export default businessFromSlice.reducer;